// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77ed97a0","455":"1c02adaa","977":"0dfe8bea"}[chunkId] + ".chunk.js";
};